import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  forwardRef
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { Claims } from '@core/authentication/claims';
import {
  AgpFormUtil,
  CvaFormGroupComponent,
  ResetOptions
} from '@liberty-financial/agp-shared';
import { abnValidator, nzbnValidator } from '@liberty-financial/ng-core';
import { CountryComponentRegistryService } from '@shared/components/country/services';

@Component({
  selector: 'business-number',
  templateUrl: './business-number.component.html',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SparkBusinessNumberComponent),
      multi: true
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SparkBusinessNumberComponent),
      multi: true
    }
  ]
})
export class SparkBusinessNumberComponent
  extends CvaFormGroupComponent<String>
  implements OnChanges
{
  @Input() isRequired = false;
  @Input() showHighlight = false;

  form = new FormControl(null as string | null, [
    this.countryService.getCountry() == Claims.Country.NewZealand
      ? nzbnValidator()
      : abnValidator()
  ]);
  formGroup = new FormGroup({
    businessNumber: this.form
  });

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isRequired) {
      AgpFormUtil.Validators.updateRequiredIfNecessary(
        this.form,
        changes.isRequired.currentValue
      );
    }
  }

  protected reset(opts?: ResetOptions | undefined): void {
    this.form?.reset(undefined, opts);
  }

  protected transformToModel = (value: any): string => {
    if (value) return value.toString();
    return '';
  };

  constructor(
    protected readonly countryService: CountryComponentRegistryService
  ) {
    super();
  }
}
